import { useEffect, useState } from "react";

export const BREAKPOINTS = {
  mobile: 768,
  desktop: 1024,
};

function getBreakpoint(width) {
  if (width < BREAKPOINTS.mobile) return "mobile";
  if (width < BREAKPOINTS.desktop) return "tablet";
  return "desktop";
}

export function useBreakpoint() {
  const [breakpoint, setBreakpoint] = useState(() =>
    typeof window !== "undefined" ? getBreakpoint(window.innerWidth) : "desktop"
  );

  useEffect(() => {
    const onResize = () => setBreakpoint(getBreakpoint(window.innerWidth));
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return breakpoint;
}

export function useIsMobile() {
  const breakpoint = useBreakpoint();
  return breakpoint === "mobile";
}

export function useIsTablet() {
  const breakpoint = useBreakpoint();
  return breakpoint === "tablet";
}

export function useIsDesktop() {
  const breakpoint = useBreakpoint();
  return breakpoint === "desktop";
}

/** Phone + tablet: sidebar uses drawer instead of fixed panel (< 1024px). */
export function useIsCompactSidebar() {
  const breakpoint = useBreakpoint();
  return breakpoint !== "desktop";
}
